import { FormEvent, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { ApiError, register } from '../lib/api';
import { safeNext } from '../lib/safe-next';

export default function Register() {
  const [params] = useSearchParams();
  const next = safeNext(params.get('next'));
  const navigate = useNavigate();
  const [identifier, setIdentifier] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    if (password !== confirm) {
      setError('两次输入的密码不一致');
      return;
    }
    if (password.length < 8) {
      setError('密码至少 8 位');
      return;
    }
    setBusy(true);
    setError('');
    try {
      await register({
        identifier,
        password,
        display_name: displayName.trim() || undefined,
      });
      navigate(next);
    } catch (err) {
      if (err instanceof ApiError && err.message.includes('identifier_taken')) {
        setError('该手机号/邮箱/用户名已注册');
      } else {
        setError('注册失败，请检查账号格式后重试');
      }
    } finally {
      setBusy(false);
    }
  }

  return (
    <section className="work-card stack" style={{ maxWidth: 420, marginInline: 'auto' }}>
      <h1 className="type-display-md text-ink">注册</h1>
      <p className="type-body-md text-ink-secondary">使用手机号、用户名或邮箱之一作为登录标识。验证期不提供自助找回密码。</p>
      <form className="stack" onSubmit={onSubmit}>
        <label className="field">
          账号（手机号 / 用户名 / 邮箱）
          <input
            className="form-control"
            value={identifier}
            onChange={(e) => setIdentifier(e.target.value)}
            required
          />
        </label>
        <label className="field">
          显示名（可选）
          <input
            className="form-control"
            value={displayName}
            onChange={(e) => setDisplayName(e.target.value)}
          />
        </label>
        <label className="field">
          密码（至少 8 位）
          <input
            className="form-control"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            minLength={8}
          />
        </label>
        <label className="field">
          确认密码
          <input
            className="form-control"
            type="password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            required
            minLength={8}
          />
        </label>
        {error ? <div className="error">{error}</div> : null}
        <button className="btn-primary" type="submit" disabled={busy}>
          {busy ? '注册中…' : '注册'}
        </button>
      </form>
      <p className="type-body-md text-ink-secondary">
        已有账号？<Link to={`/login?next=${encodeURIComponent(next)}`}>登录</Link>
      </p>
    </section>
  );
}
